module.exports = __webpack_public_path__ + "img/advisory_core_select02.ebca243d.png";